// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"14852837","40":"85c30d24","198":"b181313b","498":"6addbe94","787":"d5fa4d18"}[chunkId] + ".chunk.js";
};